import {
  EmptyQuestionModel,
  FillInTheBlankQuestionModel,
  FreeEntryQuestionModel,
  MultipleChoiceQuestionModel,
  SnippetSelectionQuestionModel,
  TextHighlightQuestionModel,
  TwoWayQuestionModel,
  PassageCorrectionQuestionModel,
  GraphingQuestionModel
} from './Question.model';

/**
 * The constructors (not instances) of the concrete question models that
 * `getQuestionModel` can return. Returns `undefined` when `questionType` does
 * not match a known model, matching the runtime object-index behavior.
 */
export type QuestionModelConstructor =
  | typeof EmptyQuestionModel
  | typeof FillInTheBlankQuestionModel
  | typeof FreeEntryQuestionModel
  | typeof MultipleChoiceQuestionModel
  | typeof PassageCorrectionQuestionModel
  | typeof SnippetSelectionQuestionModel
  | typeof TextHighlightQuestionModel
  | typeof TwoWayQuestionModel
  | typeof GraphingQuestionModel;

export function getQuestionModel(
  questionType: string
): QuestionModelConstructor | undefined {
  return {
    empty: EmptyQuestionModel,
    'fill-in-the-blank': FillInTheBlankQuestionModel,
    'free-entry': FreeEntryQuestionModel,
    'free-response': EmptyQuestionModel,
    'multiple-choice': MultipleChoiceQuestionModel,
    'passage-correction': PassageCorrectionQuestionModel,
    'snippet-selection': SnippetSelectionQuestionModel,
    'text-highlight': TextHighlightQuestionModel,
    'two-way': TwoWayQuestionModel,
    'graph-contains': GraphingQuestionModel
  }[questionType];
}
